// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2c8rE","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2Uzgt"};